'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.values = exports.CHYBA = exports.POZASTAVEN = exports.NEZTOTOZNEN = exports.ZTOTOZNEN = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _params;

exports.getCaption = getCaption;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-01-07T17:38:13Z                      #

// ##############################################################

/**
 * Stav ztotožnění subjektu vůči základním regstrům.
 */

/**
 * Ztotožněn.
 */
var ZTOTOZNEN = exports.ZTOTOZNEN = 'ZTOTOZNEN';

/**
 * Neztotožněn.
 */
var NEZTOTOZNEN = exports.NEZTOTOZNEN = 'NEZTOTOZNEN';

/**
 * Pozastaven.
 */
var POZASTAVEN = exports.POZASTAVEN = 'POZASTAVEN';

/**
 * Chyba ISZR při ztotožnění.
 */
var CHYBA = exports.CHYBA = 'CHYBA';

/**
 * Seznam všech hodnot.
 */
var values = exports.values = [ZTOTOZNEN, NEZTOTOZNEN, POZASTAVEN, CHYBA];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
var params = (_params = {}, (0, _defineProperty3.default)(_params, ZTOTOZNEN, { caption: 'Ztotožněn.' }), (0, _defineProperty3.default)(_params, NEZTOTOZNEN, { caption: 'Neztotožněn.' }), (0, _defineProperty3.default)(_params, POZASTAVEN, { caption: 'Pozastaven.' }), (0, _defineProperty3.default)(_params, CHYBA, { caption: 'Chyba ISZR při ztotožnění.' }), _params);

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
function getCaption(value) {
  return params[value].caption;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvYXBpL2dlbi9zdWJqZWt0eS92MS9TdGF2WnRvdG96bmVuaVpyLmpzeCJdLCJuYW1lcyI6WyJnZXRDYXB0aW9uIiwiWlRPVE9aTkVOIiwiTkVaVE9UT1pORU4iLCJQT1pBU1RBVkVOIiwiQ0hZQkEiLCJ2YWx1ZXMiLCJwYXJhbXMiLCJjYXB0aW9uIiwidmFsdWUiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7UUEyRGdCQSxVLEdBQUFBLFU7Ozs7QUEzRGhCO0FBQ0E7O0FBRUE7O0FBRUE7O0FBRUE7O0FBRUE7O0FBRUE7Ozs7QUFJQTs7O0FBR08sSUFBTUMsZ0NBQVksV0FBbEI7O0FBRVA7OztBQUdPLElBQU1DLG9DQUFjLGFBQXBCOztBQUVQOzs7QUFHTyxJQUFNQyxrQ0FBYSxZQUFuQjs7QUFFUDs7O0FBR08sSUFBTUMsd0JBQVEsT0FBZDs7QUFFUDs7O0FBR08sSUFBTUMsMEJBQVMsQ0FDbEJKLFNBRGtCLEVBRWxCQyxXQUZrQixFQUdsQkMsVUFIa0IsRUFJbEJDLEtBSmtCLENBQWY7O0FBT1A7OztBQUdBLElBQU1FLCtEQUNETCxTQURDLEVBQ1csRUFBQ00sU0FBUyxZQUFWLEVBRFgsMENBRURMLFdBRkMsRUFFYSxFQUFDSyxTQUFTLGNBQVYsRUFGYiwwQ0FHREosVUFIQyxFQUdZLEVBQUNJLFNBQVMsYUFBVixFQUhaLDBDQUlESCxLQUpDLEVBSU8sRUFBQ0csU0FBUyw0QkFBVixFQUpQLFdBQU47O0FBT0E7Ozs7QUFJTyxTQUFTUCxVQUFULENBQW9CUSxLQUFwQixFQUEyQjtBQUM5QixTQUFPRixPQUFPRSxLQUFQLEVBQWNELE9BQXJCO0FBQ0giLCJmaWxlIjoiU3Rhdlp0b3Rvem5lbmlaci5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBDb25mXG4vLyAjaGFzRG9jPXRydWVcblxuLy8gIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyNcblxuLy8gIyAgICAgICAgICAgICBHRU5FUk9WQU7DnSBLw5NELCBORU1PRElGSUtPVkFUISEhISAgICAgICAgICAgICAgI1xuXG4vLyAjICAgICAgICAgICAgICAgICAgMjAyNS0wMS0wN1QxNzozODoxM1ogICAgICAgICAgICAgICAgICAgICAgI1xuXG4vLyAjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjI1xuXG4vKipcbiAqIFN0YXYgenRvdG/Fvm7Em27DrSBzdWJqZWt0dSB2xa/EjWkgesOha2xhZG7DrW0gcmVnc3Ryxa9tLlxuICovXG5cbi8qKlxuICogWnRvdG/Fvm7Em24uXG4gKi9cbmV4cG9ydCBjb25zdCBaVE9UT1pORU4gPSAnWlRPVE9aTkVOJztcblxuLyoqXG4gKiBOZXp0b3Rvxb5uxJtuLlxuICovXG5leHBvcnQgY29uc3QgTkVaVE9UT1pORU4gPSAnTkVaVE9UT1pORU4nO1xuXG4vKipcbiAqIFBvemFzdGF2ZW4uXG4gKi9cbmV4cG9ydCBjb25zdCBQT1pBU1RBVkVOID0gJ1BPWkFTVEFWRU4nO1xuXG4vKipcbiAqIENoeWJhIElTWlIgcMWZaSB6dG90b8W+bsSbbsOtLlxuICovXG5leHBvcnQgY29uc3QgQ0hZQkEgPSAnQ0hZQkEnO1xuXG4vKipcbiAqIFNlem5hbSB2xaFlY2ggaG9kbm90LlxuICovXG5leHBvcnQgY29uc3QgdmFsdWVzID0gW1xuICAgIFpUT1RPWk5FTixcbiAgICBORVpUT1RPWk5FTixcbiAgICBQT1pBU1RBVkVOLFxuICAgIENIWUJBXG5dO1xuXG4vKipcbiAqIE1hcGEgZW51bXUgbmEgb2JqZWt0IHMgcG9kcm9ibm9zdG1pIG8gZW51bXUuXG4gKi9cbmNvbnN0IHBhcmFtcyA9IHtcbiAgICBbWlRPVE9aTkVOXToge2NhcHRpb246ICdadG90b8W+bsSbbi4nfSxcbiAgICBbTkVaVE9UT1pORU5dOiB7Y2FwdGlvbjogJ05lenRvdG/Fvm7Em24uJ30sXG4gICAgW1BPWkFTVEFWRU5dOiB7Y2FwdGlvbjogJ1BvemFzdGF2ZW4uJ30sXG4gICAgW0NIWUJBXToge2NhcHRpb246ICdDaHliYSBJU1pSIHDFmWkgenRvdG/Fvm7Em27DrS4nfVxufTtcblxuLyoqXG4gKiBOYcSNdGVuw60gcG9waXNrdSBlbnVtdS5cbiAqIEByZXR1cm4gcG9waXNlayBlbnVtdVxuICovXG5leHBvcnQgZnVuY3Rpb24gZ2V0Q2FwdGlvbih2YWx1ZSkge1xuICAgIHJldHVybiBwYXJhbXNbdmFsdWVdLmNhcHRpb247XG59Il19